const num = (v) => {
  const n = parseFloat(String(v ?? '').trim());
  return Number.isFinite(n) ? n : null;
};

// Number-pad friendly BP: "12080" -> "120/80"; "." or space also act as the separator.
export const formatBp = (raw) => {
  const v = String(raw || '').replace(/[.\s-]/g, '/').replace(/[^0-9/]/g, '');
  if (v.includes('/')) {
    const [s, ...rest] = v.split('/');
    return `${s.slice(0, 3)}/${rest.join('').slice(0, 3)}`;
  }
  const sysLen = /^[12]/.test(v) ? 3 : 2;
  return v.length > sysLen ? `${v.slice(0, sysLen)}/${v.slice(sysLen, sysLen + 3)}` : v;
};

export const isPaedsPatient = (p) => String(p?.token_number || '').startsWith('P');

// Returns true when a vital is outside the safe range (adult standard; child pulse range for P tokens).
export const isVitalAbnormal = (key, value, paeds = false) => {
  if (value === undefined || value === null || String(value).trim() === '') return false;
  if (key === 'bp') {
    const [s, d] = String(value).split('/').map(num);
    if (s === null) return false;
    return s > 140 || s < 90 || (d !== null && d !== undefined && (d > 90 || d < 60));
  }
  const n = num(value);
  if (n === null) return false;
  if (key === 'pr') return paeds ? (n > 140 || n < 70) : (n > 100 || n < 60);
  if (key === 'spo2') return n < 95;
  if (key === 'temp') return n > 100 || n < 96;
  return false;
};

export const VITAL_FIELDS = [
  { key: 'bp', label: 'BP', unit: 'mmHg' },
  { key: 'pr', label: 'PR', unit: '/min' },
  { key: 'spo2', label: 'SpO₂', unit: '%' },
  { key: 'temp', label: 'Temp', unit: '°F' },
  { key: 'weight', label: 'Weight', unit: 'kg' },
];

export const vitalChipClass = (abnormal) => abnormal
  ? 'text-white bg-red-600 border border-red-700 animate-pulse'
  : 'text-teal-800 bg-teal-50 border border-teal-200';

const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

// Bold bordered vitals table for printouts; abnormal values marked with a red "!".
export const vitalsTableHtml = (v = {}, paeds = false, fontPt = 10, margin = '8px auto 12px') => {
  const rows = VITAL_FIELDS.filter((f) => v[f.key] && String(v[f.key]).trim());
  if (!rows.length) return '';
  const cell = `border:1.5px solid #000;padding:4px 8px;text-align:center;font-weight:800;font-size:${fontPt}pt;color:#000;`;
  const head = rows.map((f) => `<th style="${cell}background:#e5e7eb;">${f.label} <span style="font-weight:600;font-size:${fontPt - 2}pt">(${f.unit})</span></th>`).join('');
  const vals = rows.map((f) => {
    const bad = isVitalAbnormal(f.key, v[f.key], paeds);
    return `<td style="${cell}${bad ? 'color:#b91c1c;' : ''}">${esc(v[f.key])}${bad ? ' !' : ''}</td>`;
  }).join('');
  return `<table class="vitals-table" style="border-collapse:collapse;margin:${margin};"><tr>${head}</tr><tr>${vals}</tr></table>`;
};
